import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getCategoryById, updateCategory } from '../../../api/category';
import { useToast } from '@chakra-ui/react';
import CategoryForm from './CategoryForm';

const EditCategoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const toast = useToast();

  const { data, error, isLoading } = useQuery(['category', id], () => getCategoryById(id));
console.log(data)
  const updateMutation = useMutation(updateCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('categories');
      toast({
        title: 'Category updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      navigate('/dashboard/categories');
    },
    onError: () => {
      toast({
        title: 'Failed to update category',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleSubmit = (data) => {
    updateMutation.mutate({ id, ...data });
  };

  if (isLoading) {
    // return <Spinner />;
    return <p>Loading...</p>;

  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <CategoryForm onSubmit={handleSubmit} initialData={data} isLoading={updateMutation.isLoading} />
  );
};

export default EditCategoryPage;
